import type { TFunction } from 'i18next'

export function getRecordingStatusLabel(status: string, t: TFunction<'recording'>): string {
  const key = `status.${status}` as const
  const translated = t(key, { defaultValue: '' })
  if (translated) {
    return translated
  }
  return status
}
